import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      justifyContent: 'center',
      padding: '0px!important',
      width: '100%',
      maxWidth: 680,
    },
    gridLogo: {
      marginTop: '15px!important',
    },
    logo: {
      width: 165,
    },
    loginTitle: {
      width: '100%',
      color: '#a51814',
      fontWeight: 700,
      textTransform: 'uppercase',
    },
    gridForm: {
      padding: '0 30px',
    },
    form: {
      width: '100%',
    },
    inputText: {
      margin: '5px 0!important',
      padding: '6px 35px!important',
      width: '100%',
      backgroundColor: '#fef0ef',
    },
    icon: {
      width: 20,
      height: 20,
      marginLeft: 10,
      position: 'absolute',
    },
    btnLoginType: {
      border: '1px solid #e7e7e7!important',
      color: '#787676!important',
    },
    btnLoginTypeSelected: {
      border: '1px solid #965756!important',
      color: '#a33841!important',
      background: '#f8ecec!important',
    },
    btnSubmit: {
      textTransform: 'uppercase',
      margin: '10px 0!important',
      backgroundColor: '#a51713!important',
      width: '100%',
      borderRadius: '10px!important',
    },
    btnCreateUser: {
      margin: '10px 0!important',
      backgroundColor: '#ffffff!important',
      width: '100%',
      textTransform: 'uppercase',
      color: '#b13733!important',
      border: '1px solid #dda8a6!important',
      borderRadius: '10px!important',
    },
    btnRecovePassword: {
      margin: '10px 0!important',
      width: '100%',
      color: '#484b50!important',
      fontSize: '12px!important',
    },
    titleModal: {
      margin: '10px 0!important',
      textTransform: 'uppercase',
      fontSize: '15px!important',
    },
    textModal: {
      textAlign: 'center',
      margin: '0px 0px 15px 0px!important',

      color: '#a8a8a8',
    },
    iconModal: {
      width: 45,
      height: 45,
    },
    btnModal: {
      margin: '10px 0!important',
      backgroundColor: '#a51713!important',
      bottom: '0px!important',
      maxWidth: 680,
      width: '100%',
      borderRadius: '10px!important',
    },
    btnModalSegund: {
      margin: '10px 0!important',
      color: '#75605d!important',
      backgroundColor: '#fbd3d3!important',
      bottom: '0px!important',
      maxWidth: 680,
      width: '100%',
      borderRadius: '10px!important',
    },
    btnModalWhite: {
      margin: '10px 0!important',
      border: 'solid 1px #d5c9c9!important',
      color: '#000!important',
      backgroundColor: '#fff!important',
      bottom: '0px!important',
      maxWidth: 680,
      width: '100%',
      borderRadius: '10px!important',
    },
    contentModal: {
      marginBottom: '-19px!important',
    },
    titleModalRv: {
      zIndex: 2,
      textTransform: 'uppercase',
      backgroundColor: '#a51614',
      padding: '12px 0',
      color: '#fff',
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      height: 50,
      width: '100%',
    },
    gridNameModal: {
      zIndex: 2,
      backgroundColor: '#fff',
      cursor: 'pointer',
      width: '100%',
      padding: '0 20px',
      justifyContent: 'space-between!important',
    },
    nameModal: {
      textTransform: 'none',
      margin: 0,
      color: '#4d5055',
      fontSize: '16px!important',
      textAlign: 'center',
    },
    gridTitleSegund: {
      zIndex: 2,
      backgroundColor: '#fff',
      cursor: 'pointer',
      width: '100%',
      padding: '0 0px!important',
      justifyContent: 'space-between!important',
    },
    titleSegund: {
      margin: 0,
      color: '#4d5055',
      fontSize: 15,
      textAlign: 'center',
    },
    iconArrow: {
      marginLeft: 10,
    },
    socialLoginDividerContainer: {
      marginTop: -43,
      backgroundColor: '#fff',
      padding: '0 20px',
    },
    hr: {
      marginTop: 20,
      border: '1px solid #f1f1f1!important',
      width: '100%',
    },
    titleSocialLogin: {
      color: '#484b50',
      fontWeight: 500,
    },
  }),
);

export default useStyles;
